const langtrans={
      ajxsxx:["案件信息来源：","Source of Information:"],
      ajbhh:["案件编号：","No."],
      basjj:["报案时间：","Time of Reporting:"],
      bakh:["报案人：","Name:"],
      xbbn:["性别：","Gender:"],
      badh:["报案电话：","Contact Phone No."],
      cxrxm:["出险人姓名: ","出险人姓名."],
      cxsjj:["出险时间：","Time of Incident:"],
      zjhhm:["证件号码：","ID No."],
      bdcshh:["保单号码：","Policy No."],
      bdcsxq:["保单详情","Policy Details:"],
      sszbxg:["所属保险公司：","Insurance Company:"],
      lyssym:["来源说明：","Remarks:"],
	  nan:['男','Male'],
	  nv:['女','Female'],
	}
export default langtrans;


// WEBPACK FOOTER //
// ./src/views/commonPage/details/js/parheader.vue.trans.js